import classes from './Modal.module.css';
const Modal = (props) => {
    const handleClose = () => {
        props.OnConfirmBlock(); // Close modal
        if (props.onCloseNavigate) {
            props.onCloseNavigate(); // Navigate back
        }
    };

    return (
        <div>
            <div className={classes.backdrop} onClick={handleClose} />
            <div className={classes.modal}>
             
                <header className={classes.header}>
          <div className="row">
          <div className="col-md-11">
          <h3 className='successmodalh3'>{props.title}</h3>
            </div>
            <div className="col-md-1">
            <button className={classes.closeButton} onClick={handleClose}>
            <i className="fa fa-close"></i>
            </button>
            </div>
          </div>
        </header>
                <div className={classes.content}>
                    <p>{props.message}</p>
                </div>
                <footer className={classes.actions}>
                    <button onClick={handleClose}>Close</button>
                </footer>
            </div>
        </div>
    );
}

export default Modal;

